<body>
  <div class="grid-overlay">
    <app-page-header>
      <button class="header-action-btn" (click)="goCreatePlan()">{{ 'myPlans.createNew' | translate }}</button>
    </app-page-header>
    <div class="my-plans-data">
      <div class="second-headboard">
        <h1>{{ 'myPlans.title' | translate }}</h1>
        <!-- <img src="../../../../assets/icons/2341.png" alt="logo de pasos"> -->
        <div class="linked-icons" >
          <button (click)="goBack()" >{{ 'myPlans.steps.initial' | translate }}</button>
          <button class="active"  >{{ 'myPlans.steps.plans' | translate }}</button>
          @if (!showPaymentButton) {
            <button (click)="goToPortals()">{{ 'myPlans.steps.activeSubscription' | translate }}</button>
          }
          @if (showPaymentButton) {
            <button  (click)="processPayment()">{{ 'myPlans.steps.activate' | translate }}</button>
          }</div>

          <!-- <img src="../../assets/icons/1_cuenta_off.png" alt="Paso 1: Cuenta" (click)="goToEdit()">
          <img src="../../assets/icons/2_portales_off.png" alt="Paso 2: Portal" (click)="goToTemplates()">
          <img src="../../assets/icons/3_personalizar_off.png" alt="Paso 3: Personalizar" (click)="goToFeatures()">
          <img src="../../assets/icons/4_planes_on.png" alt="Paso 4: Planes" >
        </div> -->
      </div>
      <div class="grid">
        @for ( plan of myplans; track  plan) {
          <app-plan [plan]="plan" ></app-plan>
        }

      </div>
    </div>
    <div class="options-buttons">
      <button class="back-btn" (click)="goToPortals()">{{ 'myPlans.mySubscriptions' | translate }}</button>
      <!-- <button  class="continue-btn" (click)="processPayment()" >Continuar</button> -->
      @if (urlCliente) {
        <div>
          <a href="{{urlCliente}}" target="_blank">
            @if (isActive) {
              <button class="activar-btn">{{ 'myPlans.viewPortal' | translate }}</button>
            }
          </a>
        </div>
      }
      @if (showPaymentButton) {
        <button class="activar-btn" (click)="processPayment()" >{{ 'myPlans.activateSubscription' | translate }}</button>
      }

    </div>
  </div>
</body>
